<template>
     <div class="content-wrapper">
        <div class="main-content">
           <TeacherNewForm />
        </div>
    </div>
  </template>
<script>
import TeacherNewForm from "@/components/UserLogin/TeacherNewForm.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
export default {
    components: {
        TeacherNewForm
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        updateHeadMeta() {
            const title =
                this.currentLanguage === "ar"
                    ? "انضم كمعلم - Planning Force | أنشئ حسابك كمعلم"
                    : "Join as Teacher - Planning Force | Create Your Teacher Account";

            const description =
                this.currentLanguage === "ar"
                    ? "انضم إلى فريق المعلمين في Planning Force وابدأ بتعليم الدورات التدريبية الحديثة عبر منصتنا."
                    : "Join the Planning Force teaching team and start teaching modern training courses on our platform.";

            const keywords =
                this.currentLanguage === "ar"
                    ? "انضم كمعلم, تعليم, منصات تعليمية, تعلم عن بعد, Planning Force"
                    : "join as teacher, teaching, educational platforms, e-learning, Planning Force";

            useHead({
                title: title,
                meta: [
                    { name: "description", content: description },
                    { name: "keywords", content: keywords },
                    { name: "robots", content: "index, follow" },
                    {
                        name: "author",
                        content:
                            this.currentLanguage === "ar"
                                ? "معهد Planning Force العالي للتدريب"
                                : "Planning Force High Institute for Training",
                    },
                    {
                        name: "language",
                        content: this.currentLanguage === "ar" ? "ar" : "en",
                    },

                    // Open Graph meta tags
                    { property: "og:title", content: title },
                    { property: "og:description", content: description },
                    {
                        property: "og:image",
                        content: "https://example.com/teacher-join-og-image.jpg", // Replace with your teacher join page image URL
                    },
                    { property: "og:url", content: "https://example.com/teacher-join" }, // Replace with your teacher join page URL
                    { property: "og:type", content: "website" },

                    // Twitter Card meta tags
                    { name: "twitter:card", content: "summary_large_image" },
                    { name: "twitter:title", content: title },
                    { name: "twitter:description", content: description },
                    {
                        name: "twitter:image",
                        content: "https://example.com/teacher-join-twitter-image.jpg", // Replace with your teacher join page image URL
                    },
                ],
            });
        }

    },
    mounted() {
        this.updateHeadMeta();
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                //  this.language = newLang;
                this.updateHeadMeta();
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    },
};
</script>